// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Home from "./Home";
import Form from "./Form";
import ModeSelection from "./pages/ModeSelection";
import SurfaceModeWrapper from "./pages/SurfaceModeWrapper";
import ContractorDashboard from "./pages/ContractorDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import UserDashboard from "./pages/UserDashboard";
import UserProjectDetails from "./pages/UserProjectDetails";
import InvitePage from "./pages/InvitePage";
import CompleteProfile from "./pages/CompleteProfile";

import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout";
import MultiRoomPage from "./components/MultiRoomPage";
import API_BASE from "./api/apiBase";
import AccuracyInsights from "./pages/AccuracyInsights";
import KitchenModeWrapper from "./pages/KitchenModeWrapper";
import ShareYourWall from "./pages/ShareYourWall";

console.log("API:", API_BASE);
console.log("ENV:", process.env.REACT_APP_ENV);

// Build fingerprint
const BUILD_FINGERPRINT = "DD25_FRONTEND_FINGERPRINT_EXTRACTED_1223";
console.log(BUILD_FINGERPRINT, new Date().toISOString());

function App() {
  return (
    <Router>
      <Routes>
        {/* PUBLIC */}
        <Route path="/" element={<Home />} />
        <Route path="/invite/:token" element={<InvitePage />} />
	<Route path="/complete-profile" element={<CompleteProfile />} />  {/* ← add */}

        {/* AUTHENTICATED AREA */}
        <Route
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          {/* Homeowner hub */}
          <Route path="/measure" element={<ModeSelection />} />

          {/* Dashboards */}
          <Route path="/dashboard" element={<UserDashboard />} />
          <Route path="/dashboard/project/:projectId" element={<UserProjectDetails />} />

          {/* Measurement tools */}
          <Route path="/surface-mode" element={<SurfaceModeWrapper />} />
	  <Route path="/kitchen-mode" element={<KitchenModeWrapper />} />
	  <Route path="/multiroom" element={<MultiRoomPage />} />

          {/* Back-compat / belt & suspenders */}
          <Route path="/multiroom/analyze" element={<Navigate to="/multiroom" replace />} />

          {/* Role-based dashboards */}
          <Route path="/contractor" element={<ContractorDashboard />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Route>

	{/* Accuracy-Insights */}
	 <Route path="/accuracy-insights" element={<AccuracyInsights />} />
	  
	{/* Share-Wall */}
         <Route path="/share-your-wall" element={<ShareYourWall />} />

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
